import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: {
                    Documents: "Documents",
                    Cargo: "Cargo",
                    Weight: "Weight, kg",
                    Length: "Length, cm",
                    Width: "Width, cm",
                    Height: "Height, cm",
                    Volume: "Volume, m3",
                    PackageCount: "Package Count",
                    GetShippingRates: "Get shipping rates",
                    PickupFrom: "Pickup from",
                    DeliverTo: "Deliver to",
                    StartEnterAddress: "Enter city, address or zip code",
                    StartEnterOptionalAddress: "Enter address within city (optional)",
                    StartEnterWarehouse: "Company name / branch / office / warehouse",
                    Tariffs: "Shipping costs",
                    PickupDate: "Pickup Date",
                    DeliveryDays: "Delivery Days",
                    DeliveryDate: "Delivery Date",
                    Tariff: "Shipping Costs",
                    VAT: "(VAT inc.)",
                    Select: "Select",
                    Services: "Services",
                    DoorToDoorDelivery: "Door-to-Door Delivery",
                    NotFoundResults: "Sorry, there are no results for this search. Try changing the route and/or cargo type.",
                    Monday: "Monday",
                    Tuesday: "Tuesday",
                    Wednesday: "Wednesday",
                    Thursday: "Thursday",
                    Friday: "Friday",
                    Saturday: "Saturday",
                    Sunday: "Sunday",
                    Sender: "Sender",
                    Recipient: "Recipient",
                    Street: "Street",
                    House: "House, building",
                    Office: "Flat, office",
                    AddressTo: "Address To",
                    Comment: "Comment",
                    ContactPerson: "Contact Person",
                    Phone: "Phone",
                    Country: "Country",
                    Region: "Region",
                    City: "City",
                    PostalCode: "PostalCode",
                    WarehouseFrom: "Departure Warehouse",
                    WarehouseTo: "Delivery Warehouse",
                    OrderDelivery: "Order Delivery",
                    Delivery: "Delivery",
                    TakeAnotherTariff: "Take another shipping cost"
                }
            },
            ru: {
                translation: {
                    Documents: "Документы",
                    Cargo: "Груз",
                    Weight: "Вес, кг",
                    Length: "Длина, см",
                    Width: "Ширина, см",
                    Height: "Высота, см",
                    Volume: "Объём, м3",
                    PackageCount: "Кол-во мест",
                    GetShippingRates: "Найти варианты доставки",
                    PickupFrom: "Откуда",
                    DeliverTo: "Куда",
                    StartEnterAddress: "Введите город, адрес или индекс",
                    StartEnterOptionalAddress: "Введите адрес внутри города (опционально)",
                    StartEnterWarehouse: "Наименование компании / филиал / офис / склад",
                    Tariffs: "Тарифы",
                    PickupDate: "Забор груза",
                    DeliveryDays: "Срок",
                    DeliveryDate: "Ожидаемая дата доставки",
                    Tariff: "Тариф",
                    VAT: "(с НДС)",
                    Select: "Выбрать",
                    Services: "Услуги",
                    DoorToDoorDelivery: "Доставка дверь-дверь",
                    NotFoundResults: "Варианты доставки не найдены. Попробуйте выбрать другой адрес.",
                    Monday: "Понедельник",
                    Tuesday: "Вторник",
                    Wednesday: "Среда",
                    Thursday: "Четверг",
                    Friday: "Пятница",
                    Saturday: "Суббота",
                    Sunday: "Воскресенье",
                    Sender: "Отправитель",
                    Recipient: "Получатель",
                    Street: "Улица",
                    House: "Дом, корпус",
                    Office: "Кв, офис",
                    AddressTo: "Улица, дом, корпус",
                    Comment: "Комментарий",
                    ContactPerson: "Контактное лицо",
                    Phone: "Телефон",
                    Country: "Страна",
                    Region: "Регион",
                    City: "Населенный пункт",
                    PostalCode: "Индекс",
                    WarehouseFrom: "Точка отправления",
                    WarehouseTo: "Точка доставки",
                    OrderDelivery: "Заказать доставку",
                    Delivery: "Доставка",
                    TakeAnotherTariff: "Выбрать другой тариф"
                }
            }
        },
        lng: "en",

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;


// WEBPACK FOOTER //
// ./App/services/i18n.js